import { useEffect, useState, useCallback } from 'react'
import type { BackofficeUser, PremiumTokenInput } from 'api/generated'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { UsersDialogs } from 'features/users/components/users-dialogs'
import UsersProvider, { useUsers } from 'features/users/context/users-context'
import { GenericDataTable } from 'helpers/generic-data-table'
import { membershipCodesColumns } from 'helpers/membership-codes-columns'
import {
  createMembershipCode,
  deleteMembershipCode,
  fetchMembershipCodes,
} from 'store/membershipCodes/membershipCodesSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import { EditMembershipCodesForm } from 'ui/components/EditMembershipCodesForm'

const MembershipCodesPageContent = () => {
  const dispatch = useAppDispatch()
  const { totalPages, membershipCodes } = useAppSelector(
    (state) => state.membershipCodes
  )
  const { setCurrentRow, setOpen } = useUsers()
  const [pageIndex, setPageIndex] = useState(0) // React Table uses 0-based index
  const pageSize = 20

  useEffect(() => {
    dispatch(fetchMembershipCodes(pageIndex + 1))
  }, [pageIndex, dispatch])

  const handleOpenUserDialog = useCallback(
    (user: BackofficeUser) => {
      setCurrentRow(user)
      setOpen('edit')
    },
    [setCurrentRow, setOpen]
  )

  return (
    <GenericDataTable
      columns={membershipCodesColumns({
        onDelete: (id: number) => {
          if (window.confirm('Sei sicuro di voler eliminare questo codice?')) {
            dispatch(deleteMembershipCode(id))
          }
        },
        onOpenUserDialog: handleOpenUserDialog,
      })}
      data={membershipCodes || []}
      pageCount={totalPages}
      pageIndex={pageIndex}
      pageSize={pageSize}
      onPageIndexChange={setPageIndex}
      toolbar={
        <EditMembershipCodesForm
          onCreate={(data: PremiumTokenInput) =>
            dispatch(createMembershipCode(data))
          }
        />
      }
    />
  )
}

const MembershipCodesPage = () => {
  return (
    <UsersProvider>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Codici Membership
            </h2>
            <p className='text-muted-foreground'>
              Pagina di gestione membership create
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <MembershipCodesPageContent />
        </div>
      </Main>
      <UsersDialogs />
    </UsersProvider>
  )
}

export default MembershipCodesPage
